var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.shareEnabled != 'disabled')?_c('div',{staticClass:"action-share",style:({'opacity': _vm.loading ? 0.5 : 1}),on:{"click":function($event){return _vm.UserClicked()}}},[_c('d-icon',{attrs:{"icon":_vm.icon,"size":"is-normal"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }